import React, { useState } from "react";
import { X } from "lucide-react";

const ProfileImageModal = ({ show, onClose, imageUrl }) => {
  const [loading, setLoading] = useState(true);

  if (!show) return null;

  const isPdf = imageUrl && imageUrl.toLowerCase().split('?')[0].endsWith(".pdf");

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      {/* ❌ Close Button (moved to parent backdrop so it doesn't block PDF Viewer tools) */}
      <span
        onClick={onClose}
        style={{
          position: "absolute",
          top: "24px",
          right: "24px",
          cursor: "pointer",
          zIndex: 10000,
          background: "rgba(255, 255, 255, 0.9)",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
      >
        <X size={24} color="#212129" strokeWidth={2.5} />
      </span>

      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          width: isPdf ? "80vw" : "600px",
          height: isPdf ? "85vh" : "400px",
          position: "relative",
          overflow: "hidden",
          maxWidth: "100%",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 🔄 Loader */}
        {loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f9f9f9",
              zIndex: 1,
            }}
          >
            <span>Loading...</span>
          </div>
        )}

        {/* 🖼 Image or PDF (render only if imageUrl exists) */}
        {imageUrl && (
          isPdf ? (
            <iframe
              src={imageUrl}
              title="PDF Preview"
              onLoad={() => setLoading(false)}
              onError={() => setLoading(false)}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                display: loading ? "none" : "block",
              }}
            />
          ) : (
            <img
              src={imageUrl}
              alt="Preview"
              onLoad={() => setLoading(false)}
              onError={() => setLoading(false)}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: loading ? "none" : "block",
              }}
            />
          )
        )}

        {/* ❗ Fallback */}
        {!imageUrl && !loading && (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#888",
            }}
          >
            No preview available
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileImageModal;
